import React, { FunctionComponent, SVGProps } from 'react';
import { Dropdown } from 'react-bootstrap';
import Dots from '@/assets/img/dots-3.svg';
import './ActionMenu.scss';

export type ActionMenu = {
  label: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClickHandler: (params: any) => any;
  itemClassName: string;
};

type ActionMenuProps = {
  options: ActionMenu[];
};

export const ActionMenu = ({ options }: ActionMenuProps) => {
  return (
    <Dropdown className="action-menu dot-3-btn">
      <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon">
        <img src={Dots} className="dots-icon" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="drop-down-backdrop">
        {options?.map((option: any) => (
          <Dropdown.Item className={option.itemClassName} onClick={option.onClickHandler}>
            <option.icon />
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

ActionMenu.displayName = 'ActionMenu';
